/* CAFFREY Arpeggio — page behaviour, upgrade v2 (Claude Code, launch agent BUILDER, workflow A4, 2026-10-08). The same
   behaviour as the Walk On Air, Comfort Max and Odour Smart pages (Alex: "everything has to be the same, but in a unique
   way of its own"), with Arpeggio's own elements:
   <cf-arp2-gallery>  four photos in one frame: arrows + dots SLIDE them (ease-out); swipe, arrow keys; snaps.
                      Photos 2-4 get their src only after the page has loaded (never competing with photo 1, the LCP).
   <cf-arp2-buy>      plain EU size radios -> the form's hidden [name=id] (+ bubbling change, KIT.md §4a), price, Add to
                      cart state, ?variant= URL, quantity stepper, size-table highlight, the size-chart sheet. Nothing
                      preselected: Add to cart, Shop Pay (guard) and the kit sticky bar ask for a size first.
   <cf-arp2-stage>    "Sheepskin above, support below.": each numbered disc and each name in the list opens its part's
                      card (one at a time); the disc fills amber; the card's lens shows that spot of the photo at 2x.
                      Without JS all five cards show as a list. Fix 2026-10-08 (FIXER, CHECK.md M1): after a tap the
                      card is brought on screen when it is not (reveal()).
   Safe to load more than once (defer). No dependencies. prefers-reduced-motion: no fades, no smooth scroll. */
(function () {
  if (window.CfArpPage) return;
  window.CfArpPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var phone = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function isPhone() { return !!(phone && phone.matches); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function swapIn(img) { /* srcset before src: one download, the right width */
    var set = img.getAttribute('data-arp-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', img.getAttribute('data-arp-src'));
    img.removeAttribute('data-arp-src');
    img.removeAttribute('data-arp-srcset');
  }

  /* The Klaviyo pop-up is hidden on this page (cf-arp-v2.css); Klaviyo still adds its scroll lock to <body> while it
     thinks the pop-up is open, so release it whenever it appears. */
  (function () {
    var b = document.body;
    if (!b) return;
    var free = function () { if (b.classList.contains('klaviyo-prevent-body-scrolling')) b.classList.remove('klaviyo-prevent-body-scrolling'); };
    free();
    if ('MutationObserver' in window) new MutationObserver(free).observe(b, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ---------------- gallery: arrows + dots over a snapping strip ---------------- */
  class ArpGallery extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.track = this.querySelector('[data-arp-slides]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-arp-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-arp-dot]'));
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.setAttribute('data-enhanced', '');
      var prev = this.querySelector('[data-arp-prev]');
      var next = this.querySelector('[data-arp-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
      if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
      this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });
      this.track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        self.go(self.index + (e.key === 'ArrowRight' ? 1 : -1));
      });
      var ticking = false;
      this.track.addEventListener('scroll', function () {
        if (ticking || self._raf) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.track.clientWidth || 1;
          self.mark(Math.round(self.track.scrollLeft / w));
        });
      }, { passive: true });
      /* photos 2-4: fetched once the page has loaded (or at the first touch of the gallery), so a tap never shows a gap */
      var warm = function () { self.slides.forEach(function (s) { var img = s.querySelector('img[data-arp-src]'); if (img) swapIn(img); }); };
      if (document.readyState === 'complete') setTimeout(warm, 300); else window.addEventListener('load', function () { setTimeout(warm, 300); }, { once: true });
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { self.addEventListener(ev, warm, { once: true, passive: true }); });
    }
    /* the photo visibly slides (ease-out ~0.5 s) with snapping paused until it lands; reduced motion: instant */
    go(i) {
      var n = this.slides.length;
      i = ((i % n) + n) % n;
      this.mark(i);
      var self = this, track = this.track;
      var from = track.scrollLeft, to = i * track.clientWidth;
      if (this._raf) { cancelAnimationFrame(this._raf); this._raf = null; }
      if (reduced() || Math.abs(to - from) < 2) { track.scrollLeft = to; return; }
      var dur = Math.min(900, 480 + 120 * Math.abs(to - from) / (track.clientWidth || 1));
      var t0 = null;
      track.style.scrollSnapType = 'none';
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var e = 1 - Math.pow(1 - t, 3);
        track.scrollLeft = from + (to - from) * e;
        if (t < 1) { self._raf = requestAnimationFrame(step); return; }
        self._raf = null;
        track.scrollLeft = to;
        track.style.scrollSnapType = '';
      };
      this._raf = requestAnimationFrame(step);
    }
    mark(i) {
      if (i === this.index && this._marked) return;
      this._marked = true;
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      var k = this.index;
      this.dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === k)); });
    }
  }

  /* ---------------- buy box: size radios -> kit-compatible product form ----------------
     No size is preselected: only the shopper or a ?variant= link chooses one. Until then the main "Add to cart" asks for a
     size (message under the size label, label + message + sizes scrolled into view, first size focused); Shop Pay is
     covered by a transparent guard button that asks too (Shopify greys its button while the form has no id, and a
     disabled button fires no click); the kit sticky bar reads "Choose your size" with an active "Add to cart" that
     presses the main button. */
  class ArpBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.qty = this.form.querySelector('input[name="quantity"]');
      this.msg = this.querySelector('[data-arp-size-msg]');
      this.box = this.querySelector('[data-arp-sizebox]');
      this.sizes = this.querySelector('[data-arp-sizes]');
      this.guard = this.querySelector('[data-arp-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[data-arp-size]'));
      this.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[data-arp-size]')) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        var b = e.target.closest('[data-arp-qty]');
        if (!b || !self.qty) return;
        var min = parseInt(self.qty.min, 10) || 1;
        self.qty.value = Math.max(min, (parseInt(self.qty.value, 10) || min) + Number(b.getAttribute('data-arp-qty')));
        self.qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      /* Capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler on the form. */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* Keyboard users can still reach Shopify's "More payment options" link under the guard: with no size chosen, a click
         anywhere in the payment block asks for a size instead. */
      var pay = this.querySelector('[data-arp-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-arp-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      this.chart();
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    /* "Size chart" opens the chart right here (a sheet), cloned from the Product details' Size chart row; without
       <dialog> support (or without that section) the link simply jumps to the row (opened, below). */
    chart() {
      var self = this;
      var open = this.querySelector('[data-arp-chart-open]');
      var dlg = document.querySelector('[data-arp-chart-dialog]');
      if (!open || !dlg || typeof dlg.showModal !== 'function') return;
      open.addEventListener('click', function (e) {
        if (!self.fillChart(dlg)) return;
        e.preventDefault();
        self._chartTrigger = open;
        dlg.showModal();
        var r = self.current();
        self.highlight(r ? r.getAttribute('data-title') : null);
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || (e.target.closest && e.target.closest('[data-arp-chart-close]'))) dlg.close();
      });
      dlg.addEventListener('close', function () { if (self._chartTrigger) self._chartTrigger.focus(); });
    }
    fillChart(dlg) {
      var slot = dlg.querySelector('[data-arp-chart-slot]');
      if (!slot) return false;
      if (slot.childElementCount) return true;
      var src = document.querySelector('[data-arp-chart-src]');
      if (!src) return false;
      var c = src.cloneNode(true);
      c.removeAttribute('data-arp-chart-src');
      each(c.querySelectorAll('[id]'), function (el) { el.removeAttribute('id'); });
      slot.appendChild(c);
      return true;
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    highlight(title) {
      each(document.querySelectorAll('[data-arp-row]'), function (tr) {
        tr.classList.toggle('is-current', title !== null && tr.getAttribute('data-arp-row') === title);
      });
    }
    none() {
      var any = !!this.firstAvailable();
      this.setId('');
      this.highlight(null);
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = !any;
      this.patchSticky();
    }
    select(r, byUser) {
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-arp-price]'), function (el) { el.textContent = price; });
      this.highlight(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? this.dataset.add : this.dataset.soldOut;
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    /* "Choose your size first.": message under the size label, sizes highlighted, label + message + sizes scrolled into
       view together, first size focused. */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = this.dataset.sizeError || '';
        this.msg.hidden = false;
      }
      if (this.sizes) {
        this.sizes.classList.remove('is-asking');
        void this.sizes.offsetWidth; /* restart the highlight when asked again */
        this.sizes.classList.add('is-asking');
      }
      var target = this.box || this.sizes;
      if (target) {
        var box = target.getBoundingClientRect();
        if (box.top < 72 || box.bottom > window.innerHeight - 96) {
          target.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.sizes) this.sizes.classList.remove('is-asking');
    }
    /* The kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable". */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = (this.dataset.prefix || '') + (r.getAttribute('data-label') || r.getAttribute('data-title') || '');
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      if (btn && btn.disabled) btn.disabled = false;
      if (label && label.textContent !== this.dataset.add) label.textContent = this.dataset.add;
      if (v && v.textContent !== this.dataset.choose) v.textContent = this.dataset.choose;
    }
  }

  /* ---------------- "Sheepskin above, support below." — the box back's numbered parts ---------------- */
  class ArpStage extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      this.nums = Array.prototype.slice.call(this.querySelectorAll('[data-arp-num]'));
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-arp-chip]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-arp-panel]'));
      this.img = this.querySelector('[data-arp-art]');
      if (!this.chips.length || !this.panels.length) return;
      this.setAttribute('data-enhanced', '');
      var hint = this.querySelector('[data-arp-hint]');
      if (hint) hint.hidden = false;
      this.nums.concat(this.chips).forEach(function (t) {
        t.addEventListener('click', function () { self.show(t.getAttribute('data-arp-part')); self.reveal(); });
      });
      this.chips.forEach(function (c, i) {
        c.addEventListener('keydown', function (e) {
          if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(e.key) < 0) return;
          e.preventDefault();
          var n = self.chips.length;
          var j = e.key === 'Home' ? 0 : e.key === 'End' ? n - 1 : (i + (e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1) + n) % n;
          self.show(self.chips[j].getAttribute('data-arp-part'));
          self.chips[j].focus();
          self.reveal();
        });
      });
      this.addEventListener('shopify:block:select', function (e) {
        var p = e.target.closest && e.target.closest('[data-arp-part]');
        if (p) self.show(p.getAttribute('data-arp-part'));
      });
      /* the lens reads the largest file of the photo on screen, fetched only when the stage comes near (never at load) */
      this._big = {};
      if (this.img) this.img.addEventListener('load', function () { self.paintLens(); });
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            self.io.disconnect();
            self.warmLens();
          });
        }, { rootMargin: '300px 0px' });
        this.io.observe(this);
      } else {
        this.warmLens();
      }
      var t = null;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { self.warmLens(); self.paintLens(); }, 150); }, { passive: true });
      this.show(this.getAttribute('data-part') || this.chips[0].getAttribute('data-arp-part'));
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this._init = false;
    }
    bigSrc() {
      if (!this.img) return '';
      var pic = this.img.parentElement;
      var source = isPhone() && pic ? pic.querySelector('source') : null;
      var set = source ? source.getAttribute('srcset') : this.img.getAttribute('srcset');
      if (!set) return this.img.currentSrc || this.img.src;
      var best = '', bw = 0;
      set.split(',').forEach(function (c) {
        var p = c.trim().split(/\s+/);
        var w = parseInt(p[1], 10) || 0;
        if (w > bw) { bw = w; best = p[0]; }
      });
      return best;
    }
    warmLens() {
      var self = this;
      var src = this.bigSrc();
      if (!src || this._big[src]) return;
      this._big[src] = 'loading';
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { self._big[src] = 'ready'; self.paintLens(); };
      im.onerror = function () { self._big[src] = 'failed'; };
      im.src = src;
    }
    paintLens() {
      var panel = this.querySelector('[data-arp-panel].is-on');
      var lens = panel && panel.querySelector('[data-arp-lens]');
      if (!lens || !this.img) return;
      var big = this.bigSrc();
      var src = this._big[big] === 'ready' ? big : (this.img.currentSrc || '');
      if (!src || src.indexOf('data:') === 0) return;
      var r = this.img.getBoundingClientRect();
      var W = r.width, H = r.height;
      if (!W || !H) return;
      var cs = getComputedStyle(lens);
      var tall = isPhone();
      var x = parseFloat(cs.getPropertyValue(tall ? '--xt' : '--x')) / 100;
      var y = parseFloat(cs.getPropertyValue(tall ? '--yt' : '--y')) / 100;
      if (isNaN(x) || isNaN(y)) return;
      var L = lens.clientWidth || 88;
      var bw = W * 2, bh = H * 2; /* 2x of the photo as shown */
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.style.backgroundSize = bw.toFixed(1) + 'px ' + bh.toFixed(1) + 'px';
      lens.style.backgroundPosition = (L / 2 - x * bw).toFixed(1) + 'px ' + (L / 2 - y * bh).toFixed(1) + 'px';
    }
    show(part) {
      if (!part) return;
      this.setAttribute('data-part', part);
      this.chips.forEach(function (c) { c.setAttribute('aria-expanded', String(c.getAttribute('data-arp-part') === part)); });
      this.nums.forEach(function (n) { n.toggleAttribute('data-on', n.getAttribute('data-arp-part') === part); });
      this.panels.forEach(function (p) {
        var on = p.getAttribute('data-arp-panel') === part;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-hidden', String(!on));
      });
      this.paintLens();
    }
    /* Fix 2026-10-08 (FIXER, CHECK.md M1): after a tap on a number or a name, the card that changed must be on screen.
       If it is not wholly inside the band between the header and the kit sticky bar, scroll by the smallest distance
       that shows it (smooth; instant with reduced motion). No scroll when it is already visible, on load, or in the
       theme editor. */
    reveal() {
      var card = this.querySelector('.cf-arp2-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      if (!r.height) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var gap = 12;
      var bottom = vh - gap;
      var st = document.querySelector('.cf-kit-sticky');
      if (st && getComputedStyle(st).display !== 'none') bottom -= st.offsetHeight; /* the bar shows on phones and tablets */
      var sh = document.querySelector('sticky-header');
      var type = sh ? (sh.getAttribute('data-sticky-type') || '') : 'none';
      var head = sh ? sh.offsetHeight : 0;
      var top = gap + (type === 'always' || type === 'reduce-logo-size' ? head : 0);
      var dy = 0;
      if (r.bottom > bottom) dy = r.bottom - bottom;
      if (r.top - dy < top) dy = r.top - top; /* never push the card's top off screen */
      if (dy < 0 && type === 'on-scroll-up') dy -= head; /* scrolling up brings the header back over the top */
      if (Math.abs(dy) < 2) return;
      window.scrollBy({ top: dy, left: 0, behavior: reduced() ? 'auto' : 'smooth' });
    }
  }

  /* The desktop "Size" link (and any #cf-arp2-size link) opens the Product details' Size chart row. */
  (function () {
    var openRow = function () { var d = document.querySelector('[data-arp-size-row]'); if (d) { d.open = true; var outer = d.parentElement.closest('details'); if (outer) outer.open = true; } };
    if (window.location.hash === '#cf-arp2-size') openRow();
    window.addEventListener('hashchange', function () { if (window.location.hash === '#cf-arp2-size') openRow(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#cf-arp2-size"]');
      if (a && !a.hasAttribute('data-arp-chart-open')) openRow();
    });
  })();

  [['cf-arp2-gallery', ArpGallery], ['cf-arp2-buy', ArpBuy], ['cf-arp2-stage', ArpStage]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
